import type EntryModel from 'garaje/models/entry';

export function entryApprovalMessage(entry: EntryModel): string {
  // This helper requires that the entry location and badge async relationships both be resolved prior to being passed to this function
  const isNotificationsEnabled = entry.location.content?.hostNotificationsEnabled;
  const isBadgePrintingEnabled = entry.flow.content?.badge.content?.enabled;
  if (isNotificationsEnabled && isBadgePrintingEnabled) {
    return 'Notifying host and printing badge';
  } else if (isNotificationsEnabled && !isBadgePrintingEnabled) {
    return 'Notifying host';
  } else if (!isNotificationsEnabled && isBadgePrintingEnabled) {
    return 'Printing badge';
  }
  return '';
}
